import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { errMsg } from "@/lib/errors";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw !== confirm) return toast.error("New passwords don't match");
    if (newPw.length < 6) return toast.error("New password must be at least 6 characters");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password changed");
      setOldPw(""); setNewPw(""); setConfirm("");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="border border-[#2A2A2A] bg-[#121212] p-6 mt-6 max-w-3xl">
      <div className="flex items-center gap-2 mb-4">
        <KeyRound className="h-5 w-5 text-[#FF4500]" />
        <h3 className="font-display text-xl">Change password</h3>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label className="font-mono text-xs uppercase tracking-widest text-gray-400">Current password</Label>
          <Input data-testid="cp-old" required type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)}
                 className="mt-2 rounded-none bg-black border-[#2A2A2A] font-mono h-11" />
        </div>
        <div>
          <Label className="font-mono text-xs uppercase tracking-widest text-gray-400">New password (min 6)</Label>
          <Input data-testid="cp-new" required type="password" minLength={6} value={newPw} onChange={(e) => setNewPw(e.target.value)}
                 className="mt-2 rounded-none bg-black border-[#2A2A2A] font-mono h-11" />
        </div>
        <div>
          <Label className="font-mono text-xs uppercase tracking-widest text-gray-400">Confirm new</Label>
          <Input data-testid="cp-confirm" required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
                 className="mt-2 rounded-none bg-black border-[#2A2A2A] font-mono h-11" />
        </div>
      </div>
      <Button data-testid="cp-submit" type="submit" disabled={busy}
              className="mt-6 rounded-none bg-[#FF4500] hover:bg-[#E53E00] text-black font-mono text-xs uppercase tracking-widest h-11 px-8">
        {busy ? "Updating..." : "Update password"}
      </Button>
    </form>
  );
}
